import { render, staticRenderFns } from "./PotentialClientsPopup.vue?vue&type=template&id=28a0246e"
import script from "./PotentialClientsPopup.vue?vue&type=script&lang=js"
export * from "./PotentialClientsPopup.vue?vue&type=script&lang=js"
import style0 from "./PotentialClientsPopup.vue?vue&type=style&index=0&id=28a0246e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports